module.exports = __webpack_public_path__ + "static/media/leverage.b682e72e.png";